// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import {connect} from 'react-redux'

import FieldsetPage from '../FieldsetPage'

import FilterDetails from './FilterDetails'
import TimeInterval from './TimeInterval'

import config, {FEATURE_AUDIT_VIEWER} from '../../config'

import './index.css'

// In minutes
const INITIAL_TIME = 5
let initial_values
class AuditViewer extends Component {
  constructor (props) {
    super(props)

    let now = new Date()
    let startTime = new Date(now)
    startTime.setMinutes(now.getMinutes() - INITIAL_TIME)

    initial_values = {
      startDate: startTime,
      startTime: startTime,
      endDate: now,
      endTime: now,
      severity: 'All'
    }
  }

  render () {
    if (!config[FEATURE_AUDIT_VIEWER]) {
      return null
    }

    return (
      <div className='audit-viewer'>
        <FieldsetPage
          title='Audit Viewer'
          leftFieldsetClassName={'col-lg-12 col-xl-7'}
          leftFieldsetLegend='Time Interval'
          leftFieldsetContent={<TimeInterval initialValues={initial_values}/>}
          rightFieldsetClassName={'col-lg-12 col-xl-5'}
          rightFieldsetLegend='Filter by'
          rightFieldsetContent={<FilterDetails initialValues={initial_values}/>}
        >
          <div className='text-container col-md-6 pull-left'>
            <span >Resulting Details</span>
          </div>
          <div className='log'>
            <textarea
              id='log-text-area'
              name='logs'
              defaultValue={this.props.logs}
              readOnly={true}
            />
          </div>
        </FieldsetPage>
      </div>
    )
  }
}

function mapStateToProps ({spinner, auditViewer}) {
  return {
    spinner: spinner,
    logs: auditViewer.logs
  }
}

export default connect(mapStateToProps)(AuditViewer)
